// extracted by css-extract-rspack-plugin
module.exports =  {"not-found":"Source12-r5bc__not-found","theory-button-container":"Source12-LDb8__theory-button-container"};